import { FC, useCallback } from 'react';
import ProviderList from './ProviderList';
import { Button, ButtonSizes, ButtonStyles } from '@silverfort/sf-components';
import { useDashboardContext } from './DashboardContext';
import { useHistory } from 'react-router-dom';
import { useCloudResources } from '../../hooks/useCloudResources';

const Integrations: FC = () => {
    const { integrations } = useDashboardContext();
    const { isCloudResourcesConnected } = useCloudResources();
    const history = useHistory();
    const integrationsList = Object.values(integrations);

    const onMore = useCallback(() => {
        isCloudResourcesConnected
            ? history.push('/Settings/Cloud%20Integrations')
            : history.push('/Settings/Integrations');
    }, [isCloudResourcesConnected, history]);

    return (
        <div className="flex flex-col max-h-full h-full w-full px-[3.1vw] py-[2.9vh] gap-4">
            <div className="[container-type:size] flex flex-col h-full gap-2 overflow-hidden min-h-0">
                {integrationsList
                    .filter(({ providers }) => !!Object.values(providers).length)
                    .map((integration, idx) => (
                        <ProviderList key={idx} integration={integration} />
                    ))}
            </div>
            {isCloudResourcesConnected && (
                <div className="flex p-4 gap-2 rounded-lg bg-sf-sunset-400 text-sf-white font-sf flex-col">
                    <span className="text-14 font-medium">Discover Integrations</span>
                    <span className="text-12 font-normal">
                        Discover powerful integrations to expand Silverfort's protection across your identity
                        infrastructure.
                    </span>
                    <Button
                        text="Explore"
                        buttonStyle={ButtonStyles.GradientBackground}
                        buttonSize={ButtonSizes.Medium}
                        className="self-center"
                        onClick={onMore}
                    />
                </div>
            )}
        </div>
    );
};

export default Integrations;
